import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import SalesDossier from '../../../components/dossiermanagement/salesDossier/SalesDossier'
import { translate } from 'react-polyglot'
// import { push as navigateTo } from 'react-router-redux'
import TrackingContainer from '../../../containers/tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.auth
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      /* navigateTo */
    }, dispatch)
  }
}
var decoratedComponent = TrackingContainer(SalesDossier, true)
export default connect(mapStateToProps, mapDispatchToProps)(translate()(decoratedComponent))
